import { GraduationCap } from "@phosphor-icons/react";

export default function Training() {
  return (
    <div className="space-y-6" data-testid="training-page">
      <div>
        <h1 className="font-heading text-3xl font-bold">Training</h1>
        <p className="text-muted-foreground mt-1">Staff training &amp; development</p>
      </div>
      <div className="glass border border-dashed border-border rounded-lg py-20 flex flex-col items-center gap-4 text-center px-6">
        <GraduationCap size={44} className="text-muted-foreground/50" />
        <div>
          <p className="font-heading text-lg font-semibold" data-testid="training-coming-soon">Coming soon</p>
          <p className="text-sm text-muted-foreground mt-1 max-w-md">
            Onboarding checklists, sign-offs and training records will live here. This module is a
            placeholder for now — no functionality yet.
          </p>
        </div>
      </div>
    </div>
  );
}
